import React from 'react'
import NavigationMenuItemInputCommon from "../menu-item-add-common"
import {ProjectIconDictionary} from "../../../../../../core/gd/const/project"
import menuAdd_createProductivity from "../../../menu-add-with-popover/actions/productivity/create"
import {NavigationMenuInlineAddType} from "../../../menu-add-with-popover/@types"
import {ProductivityType_ParamsMap} from "./@const"

type Props = {
    type        : NavigationMenuInlineAddType
    level?      : number
    parentId?   : ID

    onAdded     : {(isAdded:boolean):void}
}

// const debug = "NavigationMenuItemAddProductivity"
const debug = false

export default function NavigationMenuItemAddProductivity(props: Props) {

    const params = ProductivityType_ParamsMap[props.type]
    const onCommit = async (value?:string) => {
        // do nothing if no title
        if (!value) {
            props.onAdded(false)
            return
        }

        debug && console.log(debug, 'onChange', value)

        props.onAdded(true)

        const project = await menuAdd_createProductivity({
            systemType      : params.systemType,
            viewType        : params.viewType,
            parentProjectId : props.parentId,
            name            : value,
            color           : gd.session.projects.get(props.parentId)?.color,
            projectIcon     : params.projectIcon
        })

        gd.goTo(project.url)
    }

    return (
        <NavigationMenuItemInputCommon iconClass  = {ProjectIconDictionary[params.projectIcon]}
                                       level      = {props.level}
                                       parentId   = {props.parentId}
                                       onCommit   = {onCommit}/>
    )
}